import { convertLanguageToCountryCode } from "@/core/utils/languageToCountryCode"
import { PhoneNumberUtil } from "google-libphonenumber"
import { formatPhoneNumberIntl } from "react-phone-number-input"

const phoneUtil = PhoneNumberUtil.getInstance()

export const isPhoneValid = (phone: string, region: string = "DK"): boolean => {
  try {
    const parsedNumber = phoneUtil.parseAndKeepRawInput(phone, region)
    return phoneUtil.isValidNumberForRegion(parsedNumber, region)
  } catch (error) {
    return false
  }
}

export const localeCountryCode = convertLanguageToCountryCode(
  typeof navigator !== "undefined"
    ? navigator.language.slice(-2).toLocaleUpperCase()
    : "DK",
)

export const formatPhoneNumberString = (phoneNumber) => {
  //we need to check if the phone number is stored as a number or a string due to lagacy data. If it is a number we need to convert it to a string and add the + sign
  if (typeof phoneNumber === "number") {
    phoneNumber = "+" + phoneNumber.toString()
  }
  const phoneNumberObject = formatPhoneNumberIntl(phoneNumber)
  return phoneNumberObject ? phoneNumberObject : phoneNumber
}
